import React from "react";
import './newRequestContainer.scss'
import LeaveModal from "../Leave/Modal";
import PlacementDateChangeModel from "../placementDateChange/dateChange";
import PlacementChange from "../placementChange/placementChange";


const CreateRequest = () => {

    return (
        <div className="listOuterContainer ">
            <div className="align-content-center flex flex-column justify-content-around p-3">
                <div>
                <h4 className="cardTitle">Create new Requests</h4>
                <p className='subTitle gray-color body-p m-0 '>Please select an option from the below list.</p>

                </div>
                <div className='requestContainer pt-2 containerMob'>
                   <LeaveModal></LeaveModal>
                    <PlacementDateChangeModel></PlacementDateChangeModel>
                    <PlacementChange></PlacementChange>
                    
                </div>
            </div>
        </div>
    )
}
export default CreateRequest